<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><span class="tit1">TAMING</span><br/><span class="tit2">CHAOS</span><br/>WORKBOOK</h1>
<p class="sub-title">Leaders Discussion Guide</p>
<p class="author">GARY R. MILLER</p>
<p class="publisher"><img alt="image" src="images/publisher.jpg"/></p>
<p class="publisher">New York</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?56148993